import React from 'react';
import { MediaMatcher } from 'components/MediaMatcher/MediaMatcher';
import { Burger } from '../Burger/Burger';
import { Togglable } from '../Togglable/Togglable';
import { Icon } from 'theme/icons/Icon';
import { Container, IconContainer, MenuPanel, MenuItem, MenuLink, MenuRetroLink } from './HeaderMenu.styles';
import { Toggler } from '../Toggler/Toggler';
import { Times } from 'components/Times/Times';
import { ActiveDot } from 'components/Dropdown/Dropdown.styles';
import { SUPPORT_EMAIL_LINK } from 'common/constants';

export const HeaderMenu = ({
    region,
    selectedPark,
    selectedScreen,
    changeHandler,
    adminUrl,
    userDisplayName,
    isWebSocketEnabled,
}) => {
    const isSelectedScreen = (park, screen) => {
        return park.value === selectedPark && screen === selectedScreen;
    };

    const handleChange = (screen, park, toggleParent) => () => {
        changeHandler('screen')(screen);
        changeHandler('park')(park.value);
        toggleParent();
    };

    const renderParks = (toggleParent) => {
        return region.parks.map((park) => (
            <Togglable key={park.key} noClickOutside>
                {({ isOpen, handleToggle, forwardedRef }) => (
                    <>
                        <MenuItem key="menuItemLabel" onClick={handleToggle} isOpen={isOpen} isBold ref={forwardedRef}>
                            {park.text}
                            <Toggler isOpen={isOpen} />
                        </MenuItem>
                        {isOpen &&
                            park.screens.map((screen) => (
                                <MenuItem
                                    key={screen.key}
                                    isOpen
                                    isLeft
                                    onClick={handleChange(screen, park, toggleParent)}>
                                    <ActiveDot isActive={isSelectedScreen(park, screen)} />
                                    {screen}
                                </MenuItem>
                            ))}
                    </>
                )}
            </Togglable>
        ));
    };

    return (
        <Togglable>
            {({ isOpen, handleToggle, forwardedRef }) => (
                <Container ref={forwardedRef}>
                    <IconContainer isOpen={isOpen} onClick={handleToggle}>
                        {isOpen && <Times />}
                        {!isOpen && (
                            <MediaMatcher minWidth="tablet">
                                {(matches) =>
                                    matches.minWidth ? <Icon type="userWhite" size="24px" /> : <Burger size="20px" />
                                }
                            </MediaMatcher>
                        )}
                    </IconContainer>
                    {isOpen && (
                        <MenuPanel>
                            <MenuItem noLink large isBold>
                                {userDisplayName}
                                <Icon type="userWhite" />
                            </MenuItem>
                            <MediaMatcher minWidth="tablet">
                                {(matches) => (!matches.minWidth ? renderParks(handleToggle) : null)}
                            </MediaMatcher>
                            {isWebSocketEnabled && (
                                <MenuLink to={`/${selectedPark.toLowerCase()}/status`} onClick={handleToggle}>
                                    SYSTEM STATUS
                                </MenuLink>
                            )}
                            <MenuLink to={`/${selectedPark.toLowerCase()}/guide`} onClick={handleToggle}>
                                USER GUIDE
                            </MenuLink>
                            <MenuRetroLink
                                href={SUPPORT_EMAIL_LINK}
                                onClick={handleToggle}
                                title="Click to open email client">
                                SUPPORT
                            </MenuRetroLink>
                            {adminUrl && <MenuRetroLink href={adminUrl}>ADMIN CONSOLE</MenuRetroLink>}
                            <MenuLink to="/logout" onClick={handleToggle}>
                                LOG OUT
                            </MenuLink>
                        </MenuPanel>
                    )}
                </Container>
            )}
        </Togglable>
    );
};
